import * as React from "react";
import FormInput from "@src/components/ui/FormInput";
import FormSelect from "@src/components/ui/FormSelect";
import ListItem from "@src/components/ui/ListItem";
import { api, user } from "@src/services/api";
import { alert } from "@src/services/notify";

interface Props {
    onSelected?: any
    province?: any
}

interface State {
    selected: string,
    name: string,
    indirizzo_completo: string;
    page: any,
    id_categoria: any,
    comune: any,
    nome: string,
    isPubblico: any,
    isGestita: any,
    schools: any,
}

export default class SceltaScuola extends React.Component<Props, State> {
    tipologie = [
        {key: 1, value: "Scuola dell'infanzia"},
        {key: 2, value: "Scuola Primaria (elementari)"},
        {key: 3, value: "Scuola Secondaria di I grado (medie)"},
        {key: 4, value: "Scuola Secondaria di II grado (superiori)"},
        {key: 5, value: "Università"},
        {key: 6, value: "AFAM (Alta Formazione Artistica, Musicale e Coreutica)"},
        {key: 7, value: "Scuole di lingue"},
        {key: 8, value: "Collegi, convitti, educandati"},
        {key: 9, value: "Centri di formazione accreditati"},
        {key: 10, value: "Istituti o centri di formazione professionale"},
        {key: 11, value: "CPIA (Centri Provinciali per l'istruzionde degli adulti)"},
        {key: 12, value: "Scuole di recupero anni scolastici"}
    ];

    results = [
        {
            id: "1",
            name: "Istituto Alessandro Volta",
            city: "Chieri (Torino)"
        },
        {
            id: "2",
            name: "Nome Scuola",
            city: "Chieri (Torino)"
        },
        {
            id: "3",
            name: "Nome Scuola",
            city: "Chieri (Torino)"
        }
    ];

    constructor(props) {
        super(props);

        this.state = {
            selected: "",
            name: "",
            indirizzo_completo: "",
            nome: "",
            page: 1,
        }

        this.handleSelectOnChange = this.handleSelectOnChange.bind(this);
    }

    componentDidMount() {
        if(this.props.selected !== undefined) {
            this.setState({ selected: this.props.selected.id, name: this.props.selected.name, isPubblico: this.props.selected.isPubblico, isGestita: this.props.selected.isGestita });
        }
    }

    onSelected(id) {
        let school: any = this.state.schools.filter(function(item) { return item.id == id; });
console.log(school)
        this.setState({
            selected: id,
            name: school[0].name + " - " + school[0].city,
            indirizzo_completo: school[0].address,
            isPubblico: school[0].isPubblico,
            isGestita: (school[0].id_gestore !== null),
        });
    }

    handleSelectOnChange(field, value, child?) {
        console.log(field, value, child);

        if(child !== undefined && this.state[field] !== undefined) {
            let arr = this.state[field];
            arr[child] = value;

            this.setState({
                [field]: arr,
            });
        } else {
            this.setState({
                [field]: value
            });
        }
    }

    onChangePage(type) {

        if(type === 'minus' && this.state.page > 1) {
            this.setState({
                page: (this.state.page-1)
            });
        }
        if(type === 'plus') {
            this.setState({
                page: (this.state.page+1)
            });
        }

        this.setState({ schools: [], isLoading: true });

        setTimeout(() => {
            this.onSearch(false);
        }, 100);
    }

    onSelect() {
        const result = [];
        result['id'] = this.state.selected;
        result['name'] = this.state.name;
        result['indirizzo_completo'] = this.state.indirizzo_completo;
        result['isPubblico'] = this.state.isPubblico;
        result['isGestita'] = this.state.isGestita;
        this.props.onSelected(result);
    }

    getSchools(nome, comune, id_categoria, callback) {

        console.log('nome, comune, id_categoria', nome, comune, id_categoria);
        const filters = {
            query: nome,
            comune: (comune === undefined || comune == 'null') ? '' : comune,
            id_categoria: (id_categoria === undefined || id_categoria == 'null') ? '' : id_categoria,
            page: this.state.page
        };

        const queryString = Object.keys(filters).map(key => key + '=' + filters[key]).join('&');


        console.log(queryString);

        api({
            method: "GET",
            url: `scuola?${queryString}`,
        }).then((response) => {
            console.log('schools', response);
            callback(response);
        });
    }

    onSearch(reset) {
        const {
            name,
            nome,
            comune,
            id_categoria,
        } = this.state;

        console.log('onSearch', this.state);

        this.getSchools(nome, comune, id_categoria, (response) => {

            const formattedSchools = response.map((item) => {
                return {
                    id: item.id,
                    name: item.nome,
                    id_gestore: item.id_gestore,
                    isPubblico: item.check.isPubblico,
                    address: (item.hasOwnProperty('indirizzo_completo') && item.indirizzo_completo) ? item.indirizzo_completo : '',
                    city: (item.hasOwnProperty('provincia') && item.provincia) ? `${item.provincia.provincia} (${item.comune})` : ''
                }
            });

            this.setState({
                schools: formattedSchools,
                page: (reset === true) ? 1 : this.state.page,
                isLoading: false,
            })

        })
    }

    listItem(item) {
        return <ListItem key={item.id} id={item.id} text={item.name} subtext={item.address} selected={this.state.selected == item.id} onSelected={(id) => this.onSelected(id)} onConfirm={() => this.onSelect()} />
    }

    render() {
        const { selected, onSelected } = this.props;

        let title = '';

        if(this.props.type == 'Studente') {
            title = 'CERCA L\'ULTIMA SCUOLA CHE HAI FREQUENTATO';
        }
        if(this.props.type == 'Insegnante') {
            title = 'CERCA L\'ULTIMA SCUOLA CHE HAI FREQUENTATO';
        }
        if(this.props.type == 'Gestore') {
            title = 'CERCA LA SCUOLA CHE VUOI GESTIRE';
        }

        if (selected) {
            return (
                <div className="text-right"><button className="main" onClick={() => { onSelected(null) }}><span style={{fontSize: "12px", color: "#fff"}}>Seleziona un'altra scuola</span></button></div>
            );
        }

        return (
            <div className={"sceltaScuola"}>
                <div className={"title"}>{ title } </div>
                <div className={"row"} style={{marginTop: "25px", marginBottom: "0px"}}>
                    <div className={"col-sm-12"}>
                        <FormInput type={"text"} icon={"icon-school"} placeholder={"Scuola"} name={"nome"} onChange={this.handleSelectOnChange} />
                    </div>
                </div>
                <div className={"row"} style={{ marginBottom:"0px" }}>
                    <div className={"col-sm-6"}>
                        <FormInput type={"text"} icon={"icon-marker"} placeholder={"Comune"} name={"comune"} onChange={this.handleSelectOnChange} />
                    </div>
                    <div className={"col-sm-6"}>
                        <FormSelect name={"id_categoria"} values={this.tipologie} placeholder={"Tipologia"} onChange={this.handleSelectOnChange} />
                    </div>
                </div>
                <div className={"row right-pos"}>
                    <button className={"btn-default btn-cerca"} onClick={() => this.onSearch(true)} >CERCA</button>
                </div>
                {this.state.schools &&
                <hr />
                }
                <div className={"listscuole"} style={ { minHeight: (this.state.isLoading) ? '400px' : '0px' } }>
                    {
                        this.state.schools &&
                        this.state.schools.map((item) => this.listItem(item))
                    }
                </div>
                {
                    this.state.schools &&
                    this.state.schools.length > 0 &&
                    <div className={"row right-pos"} style={{marginTop: "25px", backgroundColor: '#ffffff'}} >
                        {
                            (this.state.page > 1 || this.state.isLoading === true) &&
                            <button className={""} onClick={() => this.onChangePage('minus')} style={{ backgroundColor: '#ffffff' }}  > {"<<"} </button>
                        }
                        <button className={""}>Pagina: {this.state.page}</button>
                        {
                            (this.state.schools.length == 10 || this.state.isLoading === true) &&
                            <button className={""} onClick={() => this.onChangePage('plus')} style={{ backgroundColor: '#ffffff' }} > {">>"} </button>
                        }
                    </div>
                }
                {/*
                <div className={"row right-pos"} style={{marginTop: "25px"}}>
                    {
                        this.state.schools &&
                        this.state.schools.length > 0 &&
                        <button className={"btn-default btn-scegli"} onClick={() => this.onSelect()}>Scegli</button>
                    }
                </div>
                */}
                <hr className={"dotline"} />
                {
                    this.state.isLoading !== true &&
                    (
                        
                        (this.state.schools && this.state.schools.length === 0 ) ||
                        (this.state.schools && this.state.schools.length !== 10) /* wtf? */
                    )
                    &&
                    <div className={"row find-segn"} style={{marginTop: "25px"}}>
                        <div>Non hai trovato la tua scuola?</div>
                        {
                            (this.props.type == 'Studente' || this.props.type == 'Insegnante') &&
                            <button className={"btn-default btn-orange-segn"} onClick={this.props.showModal} >Segnala una nuova scuola</button>
                        }
                        {
                            (this.props.type == 'Gestore') &&
                            <button className={"btn-default btn-orange-segn"} onClick={ () => { alert({
                                text: `Su Schoolvisor sono presenti più di 70000 scuole!<br />
                                Sei sicuro che la tua scuola non sia già presente su Schoolvisor?<br />
                                Cercala.`,
                                buttons: [
                                    { label: 'Crea nuova', type: 'cancel', cb: () => { document.location.href = '/profile/scuola?create=istituto&emptyAfterSign=1' } },
                                    { label: 'Cerca la scuola', type: 'main2', cb: () => { alert(null) } }
                                ]
                            }) } } >Segnala una nuova scuola</button>
                        }

                    </div>
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/frontend/SceltaScuola.tsx